<section id="wrapper" class="error-page">
    <div class="error-box">
        <div class="error-body text-center">
            <h3 class="text-uppercase">Error 404. Página no encontrada</h3>
            <img class="img-error img-fluid" src="assets/images/404.jpg" alt="Error 404">
            <p class="text-muted m-t-30 m-b-30">Lo sentimos, la página que estas buscando no se encuentra disponible en la aplicación.</p>
            <a routerLink="/dashboard" class="btn btn-info btn-rounded waves-effect waves-light m-b-40">Ir al inicio</a> </div>
        <footer class="footer text-center">© 2019 Swplus Tecnologías.</footer>
    </div>
</section>